import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { useQuery } from "seed/gql";
import { useGet, usePost } from "seed/api";
import l from "components/util/l";
import View from "components/presentation/chat/model/Model.view";
import { Loading } from "seed/helpers";

function Model({
  flow,
  chat,
  isAdmin,
  refreshChat,
}) {

  const isDeveloper = sessionStorage.getItem("is_developer") == "true";
  const [ruleMode, setRuleMode] = useState("DATA");

  const reqFlow = useGet(`/flows/get_settings`, { flow_id: flow.id });
  const reqModels = useGet("/chats/get_llm_models");

  const reqCollections = useQuery(`{
      collections {
        name
        schema
        uiSettings
      }
    }`, `(flow_id=${flow.id} AND is_active=true)`, {
    orderBy: "name",
    notifyOnNetworkStatusChange: false
  })

  const reqDataTypes = useQuery(`{
      appDatatypes {
        name
        structure
      }
    }`, ``, {
      notifyOnNetworkStatusChange: false
    })

  const reqRootNodes = useQuery(`{
    flowNodes {
      id
      rootName
    }
  }`,
    `flow.id=${flow.id} AND is_root=true`, {
    orderBy: "-created_at",
    notifyOnNetworkStatusChange: false
  });

  const dataReqs = {
    collections: reqCollections,
    nodes: { loading: false, data: { flowNodes: [] } },
    edges: { loading: false, data: { flowEdges: [] } },
    actions: { loading: false, data: { actions: [] } },
    dataTypes: reqDataTypes
  }

  const collections = dataReqs.collections.data?.collections || [];
  const nodes = reqRootNodes.data?.flowNodes || [];

  const rulesFilter = `flow.id=${flow.id} OR ` +
    nodes.map(node => `node.id=${node.id}`).join(" OR ") + " OR " +
    collections.map(collection => `collection.id=${collection.id}`).join(" OR ");

  const reqChatRules = useQuery(`{
      flowChatRules {
        content
        type
        settings
        node {}
        collection {}
      }
    }`,
    rulesFilter,
    {
      orderBy: "-created_at"
    });

  const [callSetSettings, reqSetSettings] = usePost("/flows/set_settings", {
    onCompleted: (data) => {
      swal(l("Guardado%PA084"), l("Cambios guardados%PA085"), "success");
      refreshChat();
      reqChatRules.refetch();
      reqFlow.refetch();
    },
    onError: (error) => {
      swal("Error", l("Ocurrió un error inesperado%PA087"), "error");
    },
  });

  useEffect(() => {
    reqCollections.refetch();
    reqRootNodes.refetch();
    reqChatRules.refetch();
    reqFlow.refetch();
  }, []);

  const onSubmit = (values) =>
    callSetSettings({ flow_id: flow.id, chat_id: chat.id, settings: values });

  const refetchQueries = () => {
    reqFlow.refetch();
    reqChatRules.refetch();
  }

  const { models = [] } = reqModels.data || {};
  const { flowChatRules = [] } = reqChatRules.data || {};
  const { chat_settings: chatSettings = {} } = reqFlow.data || {};

  if (reqFlow.loading || reqModels.loading || reqChatRules.loading || dataReqs.collections.loading) return <></>;
  if (reqSetSettings.loading) return <div className="w-100 h-75"><Loading /></div>

  const wrappedChatRules = flowChatRules.map(rule =>
    ({ action: "update", rule: { ...rule } })).map(action => {
      if (action.rule.type == "DATA")
        action.rule.collection = { ...action.rule.collection, query: action.rule.settings?.query || "" };
      return action;
    })

  const initialValues = {
    chat_settings: {
      ...chatSettings,
      model: chatSettings?.model || { name: 'gpt-4o-mini', public_name: 'GPT-4o Mini' },
      collection_id: chatSettings.collection_id || ''
    },
    flow_chat_rules: wrappedChatRules
  };

  return (
    <View
      flow={flow}
      models={models}
      nodes={nodes}
      collections={collections}
      dataReqs={dataReqs}
      chatSettings={chatSettings}
      ruleMode={ruleMode}
      isAdmin={isAdmin}
      isDeveloper={isDeveloper}
      initialValues={initialValues}
      refetchQueries={refetchQueries}
      onSubmit={onSubmit}
      setRuleMode={setRuleMode}
    />
  );
}

export default Model;